import React from 'react'
import FancySelect from './FancySelect/FancySelect'

const FancySelectRow = (props) => {
    const hasErrors = () => {
        return props.errors && props.errors[props.name]
    }

    const Errors = () => {
        return (
            <div className='inline-error'>{props.errors[props.name][0]}</div>
        )
    }

    return (
        <div className='fancy-toggle'>
            <div className='form-control my-4 my-md-3'>
                <label dangerouslySetInnerHTML={{ __html: props.label }} />
                <div>
                    <FancySelect
                        label={props.placeholder ? props.placeholder : '-- Select --'}
                        value={props.value}
                        list={props.options}
                        className={hasErrors() ? 'error' : ''}
                        setValue={value => props.handleChange({ [props.name]: value })}
                    />
                    {hasErrors() ? Errors() : ''}
                </div>
            </div>
        </div>
    )
}

export default FancySelectRow



// WEBPACK FOOTER //
// ./resources/js/elements/FancySelectRow.js